(function(){
  // --- Helpers ---
  function setPref(val) {
    var oneYear = 60*60*24*365;
    var base = 'site_pref=' + val + '; Max-Age=' + oneYear + '; Path=/; SameSite=Lax';

    // Cookie visible en ambos hosts: soylatinlover.com e int.soylatinlover.com
    document.cookie = base + '; Domain=.soylatinlover.com';

    // Copia en el host actual por compatibilidad
    document.cookie = base;
  }

  function withSkip(urlStr) {
    try {
      var u = new URL(urlStr);
      if (!u.searchParams.has('skip_geo')) u.searchParams.set('skip_geo','1');
      return u.toString();
    } catch(e) {
      return urlStr + (urlStr.indexOf('?') > -1 ? '&' : '?') + 'skip_geo=1';
    }
  }

  function goToSite(pref) {
  // Eliminar prefijo de idioma (/en, /es, etc.) del path
  var path = location.pathname + location.search;
  var cleanPath = path.replace(/^\/(en|es)(\/|$)/, '/');
  // Si quedó solo el query string sin slash, asegurarse del slash inicial
  if (cleanPath.charAt(0) !== '/') cleanPath = '/' + cleanPath;
  var base = (pref === 'co') ? 'https://soylatinlover.com' : 'https://int.soylatinlover.com';
  location.href = withSkip(base + cleanPath);
}

  // --- Init ---
  function initSwitcher(){
    var switchers = document.querySelectorAll('.site-switcher');
    if (!switchers.length) return;

    switchers.forEach(function(switcher){
      var toggle = switcher.querySelector('.switcher-toggle');
      var menu = switcher.querySelector('.switcher-menu');
      if (!toggle || !menu) return;

      toggle.addEventListener('click', function(){
        var open = switcher.classList.toggle('open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      menu.addEventListener('click', function(e){
        var btn = e.target.closest('button[data-site]');
        if (!btn) return;
        var pref = btn.getAttribute('data-site'); // 'co' | 'int'

        setPref(pref);

        // (opcional) seguimiento GTM
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({event: 'select_site_version', site_version: pref});
        } catch(e){}

        goToSite(pref);
      });

      document.addEventListener('click', function(e){
        if (!switcher.contains(e.target)) switcher.classList.remove('open');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwitcher);
  } else {
    initSwitcher();
  }
})();
